import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useRestrictedWalletCredit } from '../hooks/useRestrictedWalletCredit';
import { formatCurrency } from '../utils/formatCurrency';

/**
 * Dashboard banner shown when the user has a restricted wallet balance
 * (CP disbursement credited before KYC). Clicking it opens the KYC flow.
 * Rendered below the TopBanner on /dashboard (mounted from TopBanner.tsx).
 */
export const RestrictedWalletCreditBanner: React.FC = () => {
  const navigate = useNavigate();
  const { isRestricted, balance } = useRestrictedWalletCredit();

  if (!isRestricted) return null;

  return (
    <button
      onClick={() => navigate('/kyc/documents')}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        width: '100%',
        maxWidth: '375px',
        margin: '8px auto',
        padding: '10px 14px',
        borderRadius: '10px',
        border: '1px solid #fbbf24',
        background: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)',
        color: '#92400e',
        fontSize: '13px',
        fontWeight: 600,
        fontFamily: 'Montserrat, sans-serif',
        cursor: 'pointer',
        textAlign: 'left',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
      }}
      aria-label={`Verify your ID to spend your wallet balance of ${formatCurrency(balance)}`}
    >
      <ShieldAlert style={{ width: '18px', height: '18px', color: '#f59e0b', flexShrink: 0 }} />
      <span>
        {formatCurrency(balance)} is waiting. Verify your ID to send, buy airtime, or withdraw.
      </span>
    </button>
  );
};
